import React from 'react';
import { Link } from 'react-router-dom';
import { isSafeInternalPath } from '../model/route-action';

/** Keep ordinary link behavior, and tell the destination to carry the conversation. */
export default function ResourceLink({ to, state, children, ...props }) {
    if (!isSafeInternalPath(to)) return <span>{children}</span>;
    return <Link {...props} to={to} state={{ ...state, fromCopilot: true }}>{children}</Link>;
}
